import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/servicos',
    name: 'rota-servicos',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Serviços',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Serviços',
      icon: 'cut',
    },
    component: () => import(/* webpackChunkName: "servicos" */ '../views/servicos/Servicos.vue'),
  },
  {
    path: '/administrativo/servicos/cadastro',
    name: 'rota-servicos-cadastro',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Cadastro de serviços',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "servicos" */ '../views/servicos/cadastro/ServicosCadastro.vue'),
  },
  {
    path: '/administrativo/servicos/:id',
    name: 'rota-servicos-alteracao',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Alteração de serviços',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "servicos" */ '../views/servicos/cadastro/ServicosCadastro.vue'),
  },
]
